import { useCallback, useState } from "react";
import { mutate } from "swr";
import { salesService } from "../../api_client";

/**
 * Sets the bill-to on an unconfirmed sale. `null` bills the buyer's company
 * partner ("Same as delivery address"). Checkout calls it right before
 * charging the card, since the draft SO already exists by the time the buyer
 * picks a billing address on the payment step.
 */
export function useUpdateSaleBillingAddress() {
  const [isLoading, setLoading] = useState(false);

  const update = useCallback(async (saleId: number, billingAddressId: number | null) => {
    setLoading(true);
    try {
      await salesService.updateSaleBillingAddress(saleId, { billingAddressId });
      // Same cache keys as useUpdateSaleShippingAddress. Revalidate only —
      // passing `undefined` as data would blank the cached sale, and the
      // payment step would unmount Stripe's card element mid-payment.
      await mutate((key) => typeof key === "string" && key.startsWith("sale-details"));
    } finally {
      setLoading(false);
    }
  }, []);

  return { update, isLoading };
}
